import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState, useEffect, useMemo } from 'react';

import './CSelect.css';
import Icon from "./Icon";

const CSelect = (props) => {
    const [selectListStates, setSelectListStates] = useState({
        options: [],
        value: '',
        label: '',
        isOpen: false,
        type: 'Generic',
        disabled: false,
        required: false,
        error: false,
        helperText: '',
    });

    useEffect(() => {
        setSelectListStates({
            ...selectListStates,
            label: props.label !== undefined ? props.label : selectListStates.label,
            isOpen: props.isOpen !== undefined ? props.isOpen : selectListStates.isOpen,
            type: props.type !== undefined ? props.type : selectListStates.type,
            disabled: props.disabled !== undefined ? props.disabled : selectListStates.disabled,
            required: props.required !== undefined ? props.required : selectListStates.required,
            error: props.error !== undefined ? props.error : selectListStates.error,
            helperText: props.helperText !== undefined ? props.helperText : selectListStates.helperText,
        });
    }, [props.options, props.label, props.isOpen, props.type, props.disabled, props.error, props.required, props.helperText]);

    const [selectedValue, setSelectedValue] = useState({
        value: '',
        label: '',
    });

    const selectedOption = useMemo(() => {
        const option = props.options.find(option => option.value === props.value);
        return option ? option : { value: '', label: '' };
    }, [props.options, props.value]);

    useEffect(() => {
        setSelectedValue(selectedOption);
    }, [selectedOption]);


    const onOpen = (event) => {
        setSelectListStates((prevState) => ({
            ...prevState,
            isOpen: true,
        }));
    }

    const onClose = (event) => {
        setSelectListStates((prevState) => ({
            ...prevState,
            isOpen: false,
        }));
    }

    const handleChange = (event) => {
        let selectedValue = props.options.find(x => x.value === event.target.value);
        setSelectedValue(selectedValue);
        props.onChange(selectedValue);
    };

    const handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        const threshold = 10; // Pixels from bottom to trigger load more

        if (scrollHeight - scrollTop - clientHeight < threshold && props.onLoadMore) {
            props.onLoadMore();
        }
    };

    return (
        <div className="c-select">
            <FormControl
                fullWidth
                variant="outlined"
                required={selectListStates.required}
                error={selectListStates.error}
                className="c-select-form-control"
            >
                <InputLabel id="select-label">
                    {selectListStates.label}
                </InputLabel>
                <Select
                    className="c-select-input"
                    labelId="select-label"
                    id="select-label"
                    label={selectListStates.label}
                    value={selectedValue ? selectedValue.value : ''}
                    disabled={selectListStates.disabled}
                    onChange={handleChange}
                    IconComponent={() => <Icon name={selectListStates.isOpen ? 'arrow-up' : 'arrow-down'} className="c-select-icon" />}
                    onOpen={onOpen}
                    onClose={onClose}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 200,
                            },
                            onScroll: handleScroll,
                        },
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left"
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left"
                        },
                        getcontentanchorel: null,
                    }}
                    renderValue={(selectedValue) => {
                        const option = props.options.find(opt => opt.value === selectedValue);
                        return option?.label || '';
                    }}
                >
                    {selectListStates.type === "Generic" &&
                        props.options.map((item, index) => {
                            return (
                                <MenuItem
                                    key={item.value}
                                    value={item.value}
                                    className={item.className || ''}
                                >
                                    {item.label}
                                </MenuItem>
                            )
                        })
                    }
                    {props.isLoadingMore && (
                        <MenuItem disabled>
                            <div className="c-select-loading">
                                <div className="loading-spinner-small"></div>
                                <span>Loading more...</span>
                            </div>
                        </MenuItem>
                    )}
                </Select >
                {selectListStates.error ?
                    <FormHelperText>{selectListStates.helperText}</FormHelperText>
                    :
                    null
                }
            </FormControl >
        </div>
    )
}

export default CSelect;